import { buildHybridConsentText } from '@domain/legal/IssuerInfo';
import { getIssuerInfo } from '@infra/legal/IssuerInfoService';

export const HYBRID_CONSENT_VERSION = '1.2';

export const HYBRID_CONSENT_TITLE = 'Synchronisation et copie de sécurité — offre Hybride';

/** Texte du consentement : l'éditeur et les délais viennent des informations de l'émetteur (voir IssuerInfo). */
export function getHybridConsentText(): string {
  return buildHybridConsentText(getIssuerInfo());
}

function key(tenantId: string): string {
  return `nexxus.hybridVault.${tenantId}.consent`;
}

export function hasHybridConsent(tenantId: string): boolean {
  try {
    return localStorage.getItem(key(tenantId)) === HYBRID_CONSENT_VERSION;
  } catch {
    return false;
  }
}

export function recordHybridConsent(tenantId: string): void {
  localStorage.setItem(key(tenantId), HYBRID_CONSENT_VERSION);
}
